













import {Vue, Component, Prop} from "vue-property-decorator";
import { SegmentDataItem } from "./SegmentData";

@Component( {
    components: { }
})
export default class SegmentControl extends Vue {

    @Prop({default: []}) segmentData: SegmentDataItem[];
    @Prop() markColor: string | undefined;

    get markedStyle() {
        return { backgroundColor: this.markColor }
    }

}
